module.exports = __webpack_public_path__ + "static/media/popular2.5d314578.png";